// De dónde saca la ficha 360 las cifras del cliente: primero la cartera por lote, que el vendedor sí
// puede leer, y solo si esa no trajo celda, el detalle del crédito.
import type {
    CreditPortfolioCell,
    CreditPortfolioEntry,
    CreditPortfolioState,
} from './creditPortfolio';

/** Los cuatro motivos por los que una lectura de crédito no trae cifras. */
export type UnreadCreditState = Exclude<CreditPortfolioState, 'ready'>;

/** Las cifras del cliente, o el motivo por el que no las hay. Nunca las dos cosas a la vez. */
export type CustomerCreditFacts =
    | { entry: CreditPortfolioEntry; unreadState: null }
    | { entry: null; unreadState: UnreadCreditState };

export interface CustomerCreditFactsInput {
    /** La celda del cliente en `GET /borrowers/portfolio`, que no exige `loan.credit.read`. */
    cell: CreditPortfolioCell | undefined;
    /** El estado de la cartera entera, para el cliente que ni siquiera llegó a tener celda. */
    portfolioState: CreditPortfolioState;
    /** Las mismas cifras derivadas del detalle del crédito, que sí exige `loan.credit.read`. */
    creditEntry: CreditPortfolioEntry | null;
}

/** Por qué una celda no trae dato: su propio motivo si lo tiene, y si no el de la cartera entera. */
export function unreadCreditStateOf(
    cell: CreditPortfolioCell | undefined,
    portfolioState: CreditPortfolioState,
): UnreadCreditState {
    if (cell && cell.state !== 'ready') return cell.state;
    return portfolioState === 'ready' ? 'no-source' : portfolioState;
}

/**
 * La cartera gana sobre el detalle: trae SCI, nivel y conteos ya agregados, y se lee con el permiso
 * que el vendedor ya tiene. Con la cartera en 403 el detalle todavía puede salvar la ficha.
 */
export function customerCreditFactsOf(input: CustomerCreditFactsInput): CustomerCreditFacts {
    if (input.cell?.state === 'ready') return { entry: input.cell.entry, unreadState: null };
    if (input.creditEntry) return { entry: input.creditEntry, unreadState: null };
    return { entry: null, unreadState: unreadCreditStateOf(input.cell, input.portfolioState) };
}
